export { SeoHead as default } from './SeoHead';
